module.exports = __webpack_public_path__ + "img/chevronRightEditor.cf310f0d.svg";